import { withInstall } from '@xzx-design/utils'
import _Teleport from './src/teleport.vue'

export const Teleport = withInstall(_Teleport)
export default Teleport

export * from './src/teleport'
